import giftIcon from "@assets/icon-gift.svg";
import Button from "@components/AccessibleComponents/Button";
import { LambdaResponsePayload } from "@pages/Article/types/Alacrity";
import { OKTAUserTypeEnum } from "@store/useOKTAUserStore";

export type ArticleSubshareProps = {
  isPremium: boolean;
  userType?: OKTAUserTypeEnum;
  handleGenerateGiftURLModal: () => void;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  alacrityRes?: LambdaResponsePayload;
};

export default function ArticleSubshare({
  isPremium = false,
  userType = OKTAUserTypeEnum.ANONYMOUS,
  handleGenerateGiftURLModal,
  setIsModalOpen,
  alacrityRes,
}: ArticleSubshareProps): React.ReactElement {
  const handleClick = () => {
    if (alacrityRes) {
      setIsModalOpen(true);
    } else {
      handleGenerateGiftURLModal();
    }
  };

  return (
    <>
      {isPremium && userType === OKTAUserTypeEnum.SUBSCRIBER ? (
        <div data-testid="article-subshare-component">
          <Button
            onPress={handleClick}
            className="outline-none hover:opacity-70"
            aria-label="Gift this subscriber-only story to your friends and family"
          >
            <img
              src={giftIcon}
              width={40}
              height={40}
              alt="Share this article."
            />
          </Button>
        </div>
      ) : null}
    </>
  );
}
